import { Directive, OnInit, ViewChild, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSort } from '@angular/material/sort';
import {
  StripeVerificationSessionAdminFilterKey,
  StripeVerificationSessionSummaryDto,
} from '@workspace/data-types';
import {
  ActionButton,
  ActionMenu,
  BaseDataTableComponent,
  DataHeaderFilter,
  DataListColumn,
} from '@workspace/ng-aura';
import { Observable } from 'rxjs';

export type StripeVerificationSessionColumnKey = 'stripeSessionId' | 'user' | 'stripeReportId' | 'createdAt';

@Directive()
export abstract class AbstractStripeVerificationSessionsDataTableCoreComponent<
  T extends StripeVerificationSessionSummaryDto,
>
  extends BaseDataTableComponent<T, StripeVerificationSessionColumnKey>
  implements OnInit
{
  override topMenu = signal<ActionMenu | null>(null);
  override columns = signal<DataListColumn<StripeVerificationSessionColumnKey>[]>([
    { key: 'stripeSessionId', label: 'ID Session', display: true },
    { key: 'user', label: 'Utilisateur', display: true },
    { key: 'stripeReportId', label: 'ID Rapport', display: true },
    { key: 'createdAt', label: 'Créé le', display: true },
  ]);
  override topButtons = signal<ActionButton[]>([]);
  override itemActions = signal<ActionButton[]>([
    {
      label: 'Ouvrir',
      icon: 'open_in_new',
      onClick: (event: StripeVerificationSessionSummaryDto) => this.navigateToSession(event),
      disabled: false,
      color: 'primary',
    },
  ]);

  override filters = signal<DataHeaderFilter<StripeVerificationSessionAdminFilterKey>[]>([
    {
      label: 'ID Session',
      column: StripeVerificationSessionAdminFilterKey.StripeSessionId,
    },
  ]);

  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit(): void {
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const stripeSessionId = params.getAll(StripeVerificationSessionAdminFilterKey.StripeSessionId);
      this.filterChanged({
        changed: true,
        filter: {
          stripeSessionId: stripeSessionId.length ? stripeSessionId : [],
        },
      });
    });
  }

  navigateToSession(session: StripeVerificationSessionSummaryDto): void {
    void this.router.navigate(['/stripe-verification-sessions', session._id]);
  }

  abstract override getAll(): Observable<T[]>;
  abstract override countAll(): Observable<number>;
  override getDisplayForEntry(key: StripeVerificationSessionAdminFilterKey, rawValue: string): string {
    switch (key) {
      case StripeVerificationSessionAdminFilterKey.StripeSessionId:
        return rawValue;
      default:
        return key;
    }
  }
}
